import type { TimelineItem } from "./city-day-timeline";
/** Presentation only: exact venues may include a short break; coarse areas must touch. */
export function mergePublicPresence(
  items: TimelineItem[],
  maxGapMinutes = 5,
): TimelineItem[] {
  const result: TimelineItem[] = [];
  for (const item of items) {
    const last = result.at(-1);
    if (
      last &&
      last.kind === "stay" &&
      item.kind === "stay" &&
      ((last.precision === "area" &&
        item.precision === "area" &&
        item.label &&
        item.label === last.label &&
        last.endsAt === item.startsAt &&
        JSON.stringify(last.point) === JSON.stringify(item.point)) ||
        (last.precision === "exact" &&
          item.precision === "exact" &&
          item.placeId &&
          item.placeId === last.placeId &&
          Date.parse(item.startsAt) >= Date.parse(last.startsAt) &&
          Date.parse(item.startsAt) - Date.parse(last.endsAt) <=
            maxGapMinutes * 60_000))
    )
      last.endsAt =
        Date.parse(item.endsAt) > Date.parse(last.endsAt)
          ? item.endsAt
          : last.endsAt;
    else result.push({ ...item });
  }
  return result;
}
